
import React, { PropsWithChildren, useEffect } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './MitekConfiguration.css';
import { useMitekContext } from '../../providers/MitekProvider/MitekProvider';

interface IMitekConfigurationProps extends MappedComponentProperties {
    usingModernApi?: boolean,
    mitekQualityLevel: number,
    mitekGuidePaddingLevel: number,
    mitekRetryAmount: number,
    mitekSessionTimeout: number,
    usingMitekManualFallback: boolean,

    mitekSdkPath: string,
    mitekApiErrorCode: string,
    mitekSelfErrorCode: string,
    mitekGeneralErrorCode: string,

    confirmationPageUrl: string,
    riskBasedEsignPageUrl: string,
    pendingApprovalPageUrl: string,
    instantIssuancePageUrl: string,
    mobileWalletPageUrl: string,
    levelThreeQuestionsPageUrl: string,
    oneTimePasscodePageUrl: string,
    dataEntryPageUrl: string,
    limitedEsignPageUrl: string,
    pendingFundingUrl: string,

    hintCorruptImage: string,
    hintCvNoBarcodeFound: string,
    hintImageSmallerThanMinSize: string,
    hintMisnapAxisAngle: string,
    hintMisnapHeadOutside: string,
    hintMisnapHeadSkewed: string,
    hintMisnapHeadTooClose: string,
    hintMisnapHeadTooFar: string,
    hintMisnapReadyPose: string,
    hintMisnapReadyPost: string,
    hintMisnapSmile: string,
    hintMisnapStayStill: string,
    hintMisnapStopSmiling: string,
    hintMisnapSuccess: string,
    hintMitekErrorBusyBackground: string,
    hintMitekErrorFocus: string,
    hintMitekErrorFourCorner: string,
    hintMitekErrorGlare: string,
    hintMitekErrorHorizontalFill: string,
    hintMitekErrorLowContrast: string,
    hintMitekErrorMinPadding: string,
    hintMitekErrorMrzMissing: string,
    hintMitekErrorSkewAngle: string,
    hintMitekErrorTooDark: string,
    hintNoFaceFound: string,
    hintDefault: string,
}

export const MitekConfigurationEditConfig = {
    emptyLabel: 'Mitek Configuration',
    isEmpty: (props: PropsWithChildren<IMitekConfigurationProps>) => {
        return !props || !props.confirmationPageUrl;
    },
};

const MitekConfiguration = (props: PropsWithChildren<IMitekConfigurationProps>): JSX.Element => {
    const { setMitekProps } = useMitekContext();
    useEffect(() => {
        if (setMitekProps) {
            setMitekProps((prev) => {
                return {
                    ...prev, 
                    ...props,
                }; 
            });
        }
    }
    , [props, setMitekProps]);

    return (
        props.isInEditor ? (
            <div style={{
                textAlign: 'center',
            }}>
                <h3 style={{
                    marginTop: '1rem',
                }}>Mitek Configuration</h3>
                <p >This is not visible outside of the AEM Editor<br/>
                </p>
            </div>)
            : <></>
    );
};

export default MitekConfiguration;
